import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=2d83241a"
import script from "./visit.vue?vue&type=script&lang=js"
export * from "./visit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports